import { css } from 'styled-components';
import { theme } from '@Themes/themeOverriderFabric';

export default css`
    color: ${props => (props.color ? `${props.color}` : `${theme.palette.darkText}`)};
`;
